import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, Routes, useLocation, useNavigationType } from "react-router-dom";
import * as Sentry from "@sentry/react";

// Get environment from build-time variable or detect locally
const isProduction = process.env.NODE_ENV === "production";
const environment = isProduction ? import.meta.env.VITE_ENVIRONMENT : "development";
const release = import.meta.env.VITE_RELEASE_VERSION || "development";

let apiUrlAppendix = `-${import.meta.env.VITE_ENVIRONMENT}`;

if (import.meta.env.VITE_ENVIRONMENT === "prod") {
    apiUrlAppendix = "";
}

Sentry.init({
    dsn: "https://9865faaf9ae893cc613761e88c58814f@o1067152.ingest.us.sentry.io/4509678681849856",
    environment,
    release,
    enabled: isProduction,
    initialScope: {
        tags: { component: "client-ui" },
        contexts: {
            deployment: { hostname: window.location.hostname, origin: window.location.origin },
        },
    },
    integrations: (defaultIntegrations) => [
        ...defaultIntegrations,
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        /^\//, // Relative URLs (same origin)
        new RegExp(`^https:\\/\\/api-client${apiUrlAppendix}\\.testuj\\.to`),
        // the rest api does not have allowed the sentry headers
        //   new RegExp(`^https:\\/\\/restapi-client${apiUrlAppendix}\\.testuj\\.to`),
    ],
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
        // Validation and known benign errors we don't want to alert on
        /ResizeObserver loop limit exceeded/i,
        /NetworkError when attempting to fetch resource/i,
    ],
    denyUrls: [
        // Chrome extensions etc.
        /extensions\//i,
        /^chrome:\/\//i,
    ],
});

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
